// TabSwitch.tsx
import React from 'react';
import { TabSwitchProps } from './types';
import { ScrollText } from 'lucide-react';

const TabSwitch: React.FC<TabSwitchProps> = ({ 
  activeTab, 
  onTabChange, 
  medicineCount, 
}) => {
  return (
    <div className="flex">
      <button
        onClick={() => onTabChange('medicine')}
        className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          activeTab === 'medicine'
            ? ' text-green-600'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        <ScrollText className='w-4 h-4 mr-2' />
        Medicines Orders - {medicineCount}
      </button>
      
    </div>
  );
};

export default TabSwitch;
